import React, { FunctionComponent } from 'react';
import { connect, DispatchProp } from 'react-redux';
import FormatLineSpacingIcon from '@mui/icons-material/FormatLineSpacing';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

import { verticallyDistributeSelectedItems } from '../../modules/annotations/paperActions';

type Props = DispatchProp<any>;

const VerticallyDistribute: FunctionComponent<Props> = ({ dispatch }) => (
  <Tooltip disableInteractive disableFocusListener id="remove-page-tooltip" title="Vertically Distribute">
    <div>
      <IconButton
        sx={{ borderRadius: 0 }}
        aria-label="Vertically Distribute"
        onClick={() => verticallyDistributeSelectedItems(dispatch)}
      >
        <FormatLineSpacingIcon sx={{ transform: 'rotate(0deg)' }} />
      </IconButton>
    </div>
  </Tooltip>
);

export default connect()(VerticallyDistribute);
